// This is a simple store that allows us to subscribe to changes in the statsig context
// and trigger a re-render of components that depend on the statsig context.
// This is used to avoid remounting components when the statsig context changes.
class StatsigStore {
	private listeners = new Set<() => void>();
	private updateCount = 0;

	subscribe = (listener: () => void): (() => void) => {
		this.listeners.add(listener);
		return () => this.listeners.delete(listener);
	};

	emitChange = (): void => {
		this.updateCount++;
		this.listeners.forEach((listener) => listener());
	};

	getSnapshot = (): number => this.updateCount;
}

export const statsigStore = new StatsigStore();
